// A toast: one line in the corner, a link, gone after a while. Used when a stable
// you follow enters the ring. Reduced motion gets it without the slide (css).
import { T } from "./timing.ts";

/**
 * @param html the line (already escaped)
 * @param href where it leads
 */
export function toast(html: string, href: string, doc: Document = document): HTMLAnchorElement {
  doc.querySelectorAll(".toast").forEach((el) => el.remove()); // one at a time
  const el = doc.createElement("a");
  el.className = "toast";
  el.href = href;
  el.innerHTML = html;
  doc.body.appendChild(el);
  requestAnimationFrame(() => el.classList.add("in"));
  setTimeout(() => el.remove(), T.TOAST);
  return el;
}

/**
 * What to say when a bout starts, if a corner belongs to a stable on the list; else nothing.
 *
 * @param following handles
 */
export function announce(ev: StartedEvent, following: string[]): { html: string; href: string } | null {
  const esc = (s: string) =>
    s.replace(/[&<>"]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" })[c] || c);
  const mine = new Set(following.map((h) => h.toLowerCase()));
  for (const f of [ev.east, ev.west]) {
    if (f && f.owner && mine.has(f.owner.toLowerCase())) {
      return { html: `<b>${esc(f.name)}</b> of ${esc(f.owner)}'s stable enters the ring`, href: `/bout/${ev.bout_id}` };
    }
  }
  return null;
}
